import React, { useState } from "react";
import Button from "./Button";

/**
 * RefreshButton - Универсальная кнопка для сброса кэша и обновления данных
 * @param {Function} onRefresh - Функция, которая будет вызвана при нажатии
 * @param {string} className - Дополнительные CSS классы
 * @param {string} label - Текст кнопки (по умолчанию "Обновить")
 * @param {string} title - Текст подсказки (tooltip)
 */
export const RefreshButton = ({
  onRefresh,
  className = "",
  label = "Обновить",
  title = "Загрузить актуальные данные из базы",
}) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (isRefreshing) return;

    setIsRefreshing(true);
    try {
      await onRefresh();
    } finally {
      // Искусственная задержка для плавности анимации, если запрос слишком быстрый
      setTimeout(() => setIsRefreshing(false), 600);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleRefresh}
      disabled={isRefreshing}
      title={title}
      className={`group flex items-center gap-2 transition-all duration-300 ${isRefreshing ? "opacity-70" : ""} ${className}`}
    >
      <span
        className={`inline-block text-base ${isRefreshing ? "animate-spin-slow" : "group-hover:rotate-180 transition-transform duration-500"}`}
      >
        🔄
      </span>
      {label && (
        <span className="font-medium">
          {isRefreshing ? "Обновление..." : label}
        </span>
      )}
    </Button>
  );
};

export default RefreshButton;
